module.exports = __webpack_public_path__ + "img/xx.33e15cdd.svg";